module.exports = __webpack_public_path__ + "/images/ico-color-clipboard.914069d.svg";